
import { TYPES } from "./types"

// Builds the `body` argument for the startRecordOnDns mutation.
export const buildRecordBody = (e) => JSON.stringify({
  id: e.conferenceKey,
  stream: {
    name: e.conferenceKey,
    variantNames: ["video_4000", "bypass_audio"]
  },
  interval: 900000,
  segmentationRule: "continuity"
})

export const startEventRecSuccess = (e) => ({ type: TYPES.START_EVENT_SUCCESS, payload: e })
export const stopEventRecSuccess = (e) => ({ type: TYPES.STOP_EVENT_SUCCESS, payload: e })
export const changeStandByType = (e) => async ( dispatch) => {
  dispatch({ type: TYPES.CHANGE_MODE_EVENT_SUCCESS, payload: e })

}
export function setPaginationProps(e) {
  return {
    type: "SET_PaginationProps",
    payload: e,
  }
}

export function setshowVideosActions(e) {

  return {
    type: "SET_ShowVideos",
    payload: e,
  }

}
export function setSDIStation(e) {

  return {
    type: "SET_SDI_station",
    payload: e,
  }

}
export function setThemes(e) {

  return {
    type: "SET_THEMES",
    payload: e,
  }
}
export function setcurrentStatus(e) {

  return {
    type: "CURRENT_STATUS",
    payload: e,
  }

}

export function setFilterVideosActions(e) {

  return {
    type: "SET_FilterVideos",
    payload: e,
  }


}

export function setshowDivsConditions(e) {
  return {
    type: "SET_showDivsConditions",
    payload: e
  }
}

export const changeLang = (lang) => ({
  type: "CHANGE_LANG",
  payload: lang
})

export function setLoadingDeleteShowVideo(e) {
  return {
    type: "SET_LoadingDeleteShowVideo",
    payload: e
  }
}

export function setConfirmMultiDelete(e){
  return {
    type:"SET_ConfirmMultiDelete",
    payload:e 
  }
 
}

export function setDeleteMultiEvents(e){ 
  return {
   type:"SET_DeleteMultiEvents",
   payload:e 
 }
}


export function setIndexationEvent(e){ 
  return {
   type:"SET_IndexationEvent",
   payload:e 
 }
}


export function setTrackedDelay(e){ 
  return {
   type:"SET_IndexationEventDelay",
   payload:e 
 }
}
export function setLiveStreamStatus(e){ 
  return {
   type:"SET_LiveStreamStatus",
   payload:e 
 }
}
export function setEventEnded(e){ 
  return {
   type:"SET_EventEnded",
   payload:e 
 }
}
export function setEventStarted(e){ 
  return {
   type:"SET_EventStarted",
   payload:e 
 }
}

export function setActionEventIndex(data){
  return {
   type:"SET_IndexationEventAction",
   payload:data 
 }
}